<ng-template #linkItem let-link>
  <fcom-link
    [href]="link.href"
    [icon]="mode() === 'list' ? { position: IconPosition.RIGHT, name: SvgLibraryIcon.ARROW_RIGHT } : undefined"
    >{{ link.translationKey | finLocalization }}</fcom-link
  >
</ng-template>

@if (mode() === 'list') {
  <ul class="no-list-style" role="list">
    @for (link of links; track link.href) {
      <li class="ps-small-b">
        <ng-container *ngTemplateOutlet="linkItem; context: { $implicit: link }" />
      </li>
    }
  </ul>
} @else {
  <div class="nordic-blue-50-bg surface-secondary">
    <div class="grid-col-12 grid-max-width">
      <div class="col-1-12">
        <ul class="ribbon-list g-large no-list-style ms-medium-y" role="list">
          @for (link of links; track link.href) {
            <li role="listitem">
              <ng-container *ngTemplateOutlet="linkItem; context: { $implicit: link }" />
            </li>
          }
        </ul>
      </div>
    </div>
  </div>
}
